<template>
    <div id="template" class="mt">
        <a-row type="flex" justify="start">
            <a-tooltip placement="topLeft">
                <template slot="title">
                    <span>{{ $t('generic.Add') }}</span>
                </template>
                <img @click="AddTmp" style="margin-left: 4px;" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
            </a-tooltip>
            <a-popconfirm
                :title="$t('generic.AreyoudeleTask')"
                @confirm="cancelTmpl('arr')"
                :okText="$t('generic.Yes')"
                :cancelText="$t('generic.No')"
            >
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{$t('publicLang.Cancel')}}</span>
                    </template>
                    <img style="margin-left: 4px;" class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                </a-tooltip>
            </a-popconfirm>
        </a-row>
        <a-row style="margin-top: 10px">
            <vxe-table
                border
                resizable
                highlight-hover-row
                ref="templateTableRef"
                @cell-dblclick="editTmpl"
                size="mini"
                :data="tableData">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="tplName" :title="$t('generic.TemplateName')" minWidth="150"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="tplVersion" :title="$t('reportSetting.Version')" minWidth="100"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="status" :title="$t('generic.Status')" minWidth="100"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="createTime" :title="$t('roleGe.CreateTime')" minWidth="150"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifier" :title="$t('roleGe.Modifier')" minWidth="150"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifyTime" :title="$t('roleGe.ModifiyTime')" minWidth="150"></vxe-table-column>
            </vxe-table>
        </a-row>

        <a-modal
            :title="$t('pubGicSet.AdvanceSearch')"
            :visible="Addvisible"
            @cancel="handleCancel"
            width="65%"
        >
            <template slot="footer">
                <a-button type="primary" @click="addTml">{{$t('publicLang.Save')}}</a-button>
            </template>
         <a-row type="flex" justify="start" style="margin-bottom: 10px;">
             <a-col>
                 <a-select :placeholder="$t('publicLang.PleaseSelect')" style="width: 120px" size="small" v-if="addEditType" v-model="tmplNameModel" @change="tmplChangeDetail">
                     <a-select-option v-for="item in tableData" :key="item.tplName" >{{item.tplName }}</a-select-option>
                 </a-select>
                 <a-col v-else>
                     <label style="color: red; margin-right: 4px;">*</label>
                     <a-input :placeholder="$t('publicLang.PleaseEnter')" v-model="tmplNameModel" style="width: 120px" size="small" />
                 </a-col>
             </a-col>
             <a-col v-if="EditType">
                 <a-input :placeholder="$t('publicLang.PleaseEnter')" v-model="newTplName" style="width: 120px;margin: 0 4px;" size="small"  />
             </a-col>
             <a-col >
                 <a-col>
                     <a-tooltip placement="topLeft">
                         <template slot="title">
                             <span>{{ $t('generic.Add') }}</span>
                         </template>
                         <a-button
                                 size="small"
                                 type="primary"
                                 shape="circle"
                                 icon= 'rollback'
                                 class="ml"
                                 @click="newTmplName"
                                 v-if="!addEditType"
                         ></a-button>
                         <img v-else @click="newTmplName" style="margin:0 4px;" class="sbxs" src="../../../assets/img/ss-add.png" width="22" height="22">
                     </a-tooltip>
                     <a-tooltip placement="topLeft">
                         <template slot="title">
                             <span>{{ $t('roleGe.Edit') }}</span>
                         </template>
                         <a-button
                                 class="ml"
                                 size="small"
                                 type="primary"
                                 shape="circle"
                                 :icon="EditType ? 'rollback': 'edit'"
                                 style="background: #9c9446;border:none"
                                 @click="editTmplName('edit')"
                         ></a-button>
                     </a-tooltip>
                     <a-popconfirm
                             :title="$t('generic.AreyoudeleTask')"
                             @confirm="cancelTmpl"
                             :okText="$t('generic.Yes')"
                             :cancelText="$t('generic.No')"
                     >
                         <a-tooltip placement="topLeft">
                             <template slot="title">
                                 <span>{{ $t('generic.Delete') }}</span>
                             </template>
                             <img style="margin:0 4px;" class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                         </a-tooltip>
                     </a-popconfirm>

                     <a-tooltip placement="topLeft">
                         <template slot="title">
                             <span>{{ $t('publicLang.Save') }}</span>
                         </template>
                         <a-button class="ml" shape="circle" icon="check" type="primary" @click="addTml" size="small"></a-button>
                     </a-tooltip>
                     <a-dropdown>
                          <span>
                               <img style="margin:0 4px;" class="sbxs" src="../../../assets/img/ss-more.png" width="22" height="22">
                            </span>
                         <a-menu slot="overlay">
                             <a-menu-item @click="clearAdvansearData">Clear</a-menu-item>
                             <a-menu-item>Copy from Master</a-menu-item>
                         </a-menu>
                     </a-dropdown>
                 </a-col>
             </a-col>
         </a-row>
            <a-row class="infoError" v-if="infoError">{{$t('publicLang.Required')}}</a-row>
            <a-row><and-or :options="options" :isFirst='isFirst' ref="tmlAndOr"></and-or></a-row>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import andOr from "./queryBuilder/components/AndOR.vue";
    export default{
        components: {
            andOr,
        },
        props:{
            headerUid: {
                type: String,
                default: function() {
                    return '';
                }
            },
        },
        data(){
            return{
                Addvisible: false,
                tableData: [], // table data
                isFirst: true,
                options: {
                    // query filter 下拉
                    condition: [],
                    fieldNameSel: [],
                    status: []
                },
                addEditType: true, // add edit input 查询select
                EditType: false, // 是否编辑tamlplate
                infoError: false, // 报错提示
                tmplNameModel: null, // 新增模板名字
                newTplName: null, // 编辑模板名字
            }
        },
        watch:{
            headerUid(v){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
//            初始化table
            init(){
                ajax.get(api.REPORTGENERICTEMPLATELIST,{headerUid: this.headerUid}).then(res=>{
                    this.tableData = res.data
                })
            },
//            添加template 下拉数据
            AddTmp(){
                this.Addvisible = true
                ajax.get(api.REPORTGENERICSEARCHABLEFIELD,{headerUid: this.headerUid}).then(res=>{
                    this.options.fieldNameSel = res.data
                })
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                })
            },
            clearAddTmplData(){
                //                去除缓存
                this.$nextTick(()=>{
                    this.$refs.tmlAndOr.fillFormStatus(undefined);
                    this.tmplNameModel = null
                    this.addEditType = true
                    this.EditType = false
                    this.newTplName = null
                })
            },
//            取消添加
            handleCancel(){
                this.Addvisible = false
                this.clearAddTmplData()
            },
//            点击save 保存template
            addTml(){
                let params = {
                    condition: JSON.stringify(this.$refs.tmlAndOr.queryFormStatus()),
                    headerUid: this.headerUid,
                    tplName: this.tmplNameModel,
                    type: 'SYS',
                    newTplName: this.newTplName
                }
                if(!this.tmplNameModel){
                    this.infoError = true
                    return
                }else{
                    this.infoError = false
                }
                ajax.post(api.REPORTGENERICTEMPLATE,params).then(res=>{
                    if(res.code == 200){
                        this.handleCancel()
                        this.init()
                        this.$message.success(res.msg);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
//            new 添加出现输入框
            newTmplName(){
                this.tmplNameModel = ''
                this.$refs.tmlAndOr.fillFormStatus(undefined);
                this.addEditType = !this.addEditType
            },
//            edit Tamplate
            editTmpl({row}){
                this.AddTmp()
                ajax.get(api.REPORTGENERICTEMPLATE,{headerUid: this.headerUid,templateName: row.tplName,type: 'SYS'}).then(res=>{
                    if(res.code == 200){
                        this.$nextTick(()=>{
                            this.$refs.tmlAndOr.fillFormStatus(JSON.parse(res.data));
                        })
                        this.tmplNameModel =  row.tplName
                    }
                })
            },
            tmplChangeDetail(item){
                ajax.get(api.REPORTGENERICTEMPLATE,{headerUid: this.headerUid,templateName: item,type: 'SYS'}).then(res=>{
                    if(res.code == 200){
                        this.$nextTick(()=>{
                            this.$refs.tmlAndOr.fillFormStatus(JSON.parse(res.data));
                        })
                        this.AddTmp()
                    }
                })
            },
//            编辑tanplate Name
            editTmplName(){
                this.EditType = !this.EditType
            },
//            删除
            cancelTmpl(type){
                let arr = []
                if(type == 'arr'){
                    let v = this.$refs.templateTableRef.getCheckboxRecords()
                    if(v.length > 0){
                        for(let i in v){
                            arr.push(v[i].tplName)
                        }
                    }else{
                        return
                    }
                }else{
                    arr = [this.tmplNameModel]
                }
                let params ={
                    headerUid: this.headerUid,
                    tplNameList: arr,
                    type: "SYS"
                }
                ajax.post(api.REPORTGENERICTEMPLATEDELETION,params).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.init()
                        this.tmplNameModel = null
                        this.$refs.tmlAndOr.fillFormStatus(undefined);
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
//            clear
            clearAdvansearData(){
                this.$refs.tmlAndOr.fillFormStatus(undefined);
            }
        }
    }
</script>
<style>
    @import "../../../assets/css/bootstrap.css";
    .ml{
        margin-left: 4px;
    }
</style>